import { ReactNode } from 'react'

/** A phone-shaped frame used to host the live preview (indiepa.ge style). */
export function PhoneFrame({ children, footer }: { children: ReactNode; footer?: ReactNode }) {
  return (
    <div className="mx-auto w-full max-w-[360px]">
      <div className="rounded-[2.2rem] border-[6px] border-zinc-800 bg-zinc-900 p-2 shadow-2xl">
        <div className="relative h-[640px] overflow-hidden rounded-[1.7rem] bg-white">
          {children}
        </div>
        {footer && <div className="px-3 py-2 text-center text-xs text-zinc-500">{footer}</div>}
      </div>
    </div>
  )
}
